import { useEffect } from "react";
import { Suspense, lazy } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { FooterProvider, useFooter } from './FooterContext';
import ScrollToTop from "./ScrollToTop";
import './CSS/App.css';

const Navbar = lazy(() => import('./Navbar'));
const Footer = lazy(() => import('./Footer'));

const Home                  = lazy(() => import('./Home'));
const Works                 = lazy(() => import('./Works'));
const Login                 = lazy(() => import('./Login'));
const Register              = lazy(() => import('./Register'));
const ForgotPWD             = lazy(() => import('./Forgot_PWD'));
const Terms                 = lazy(() => import('./Terms'));
const Privacy               = lazy(() => import('./Privacy'));
const Notifys               = lazy(() => import('./Notifys'));
const Designs               = lazy(() => import('./Designs'));
const Designs_View          = lazy(() => import('./Designs_View'));
const Articles              = lazy(() => import('./Articles'));
const ArticleDetail         = lazy(() => import('./ArticleDetail'));
const AIRender              = lazy(() => import('./AIRender'));
const Studio_Edit           = lazy(() => import('./Studio_Edit'));
const Studio_From           = lazy(() => import('./Studio_From'));
const Studio_From_Proposal  = lazy(() => import('./Studio_From_Proposal'));
const Studio_Request        = lazy(() => import('./Studio_Request'));
const Studio_Request_List   = lazy(() => import('./Studio_Request_List'));
const Studio_Request_View   = lazy(() => import('./Studio_Request_View'));
//const User_Credit           = lazy(() => import('./User_Credit'));
const User_Favo             = lazy(() => import('./User_Favo'));
const User_From             = lazy(() => import('./User_From'));
const User_Profile          = lazy(() => import('./User_Profile'));
const User_Request          = lazy(() => import('./User_Request'));
const User_Studio           = lazy(() => import('./User_Studio'));
const Client                = lazy(() => import('./Client'));
const CompanyFAQ            = lazy(() => import('./CompanyFAQ'));
const DesignMindMap         = lazy(() => import('./DesignMindMap'));

function NavbarSkeleton() {
  return (
    <div style={{height: '60px', background: '#eee', display:'flex', alignItems:'center', padding:'0 20px'}}>
      <div style={{width: '120px', height: '20px', background:'#ccc', borderRadius:'4px'}}></div>
    </div>
  );
}

function FooterSkeleton() {
  return (
    <div style={{height: '100px', background: '#f5f5f5', display:'flex', justifyContent:'center', alignItems:'center'}}>
      <div style={{width: '200px', height: '15px', background:'#ddd', borderRadius:'4px'}}></div>
    </div>
  );
}

function AppContent() {

  const location = useLocation();
  const noNavbar = ['/login', '/register','/client/create-need','/forgotpwd','/reset-password','/companies/create','/usercredit'];

  const { showFooter, setShowFooter } = useFooter();
  const alwaysShowFooter = ['/', '/how-it-works', '/articles', '/company-faq', '/ai-render', '/terms', '/privacy'];

  useEffect(() => {
    const isAlwaysShowFooter = alwaysShowFooter.includes(location.pathname) ||
                               location.pathname.startsWith('/articles/');

    if (isAlwaysShowFooter) {
      setShowFooter(true);
    } else {
      setShowFooter(false);
    }
  }, [location.pathname]);

  return (
    <div className='DIV_Body'>
      {!noNavbar.includes(location.pathname) && (
        <Suspense fallback={<NavbarSkeleton />}>
          <Navbar />
        </Suspense>
      )}

      <div className="Content">
        <ScrollToTop />
        <Suspense fallback={<div style={{padding:"20px", textAlign:"center"}}>Loading...</div>}>
          <Routes>
            <Route path="/"                          element={<Home />} />
            <Route path="/how-it-works"              element={<Works />} />
            <Route path="/company-faq"               element={<CompanyFAQ />} />
            <Route path="/login"                     element={<Login />} />
            <Route path="/register"                  element={<Register />} />
            <Route path="/forgotpwd"                 element={<ForgotPWD />} />
            <Route path="/reset-password"            element={<ForgotPWD />} />
            <Route path="/terms"                     element={<Terms />} />
            <Route path="/privacy"                   element={<Privacy />} />
            <Route path="/client/messages"           element={<Notifys />} />
            <Route path="/design-styles"             element={<Designs />} />
            <Route path="/design-portfolio"          element={<Designs_View />} />
            <Route path="/articles"                  element={<Articles />} />
            <Route path="/articles/:id"              element={<ArticleDetail />} />
            <Route path="/ai-render"                 element={<AIRender />} />
            <Route path="/companies/profile/edit"    element={<Studio_Edit />} />
            <Route path="/companies/create"          element={<Studio_From />} />
            <Route path="/companies/proposal/upload" element={<Studio_From_Proposal />} />
            <Route path="/companies/proposal"        element={<Studio_Request />} />
            <Route path="/design-needs"              element={<Studio_Request_List />} />
            <Route path="/design-needs/:needId"      element={<Studio_Request_View />} />
            <Route path="/client/favorites"          element={<User_Favo />} />
            <Route path="/client/create-need"        element={<User_From />} />
            <Route path="/client/settings"           element={<User_Profile />} />
            <Route path="/client/needs"              element={<User_Request />} />
            <Route path="/design-companies"          element={<User_Studio />} />
            <Route path="/client"                    element={<Client />} />
            <Route path="/design-mindmap"            element={<DesignMindMap />} />
          </Routes>
        </Suspense>
      </div>

      {showFooter && (
        <div className={location.pathname === '/' ? 'footer-no-margin' : ''}>
          <Suspense fallback={<FooterSkeleton />}>
            <Footer />
          </Suspense>
        </div>
      )}
      </div>

  );
}

export default function App() {
  return (
    <FooterProvider>
      <AppContent />
    </FooterProvider>
  );
}